import {useSnackBar} from "@hooks/alert/useSnackBar";
import {buildErrorsMessages} from "@ui/errors/helpers/helpers";
import {OnShowError} from "@baseTypes/base";

export function useShowError(){

    const{setSnackBar} = useSnackBar()

    const onShowError:OnShowError = (e:any)=>{
        const message = buildErrorsMessages(e)
        setSnackBar({
            message:message,
            variant:'error'
        })
    }

    return {
        onShowError
    }
}